import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
document.addEventListener('DOMContentLoaded', () => {
    // Cards slider
    new Splide('.abi__banner-slider', {
        arrows: false,
        autoHeight: true,
        pagination: true,
        autoplay: true,
        type: 'loop',
        gap: 0,
        perPage: 1,
        padding: '0%',
    }).mount();
});
